import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import client from "../api/client";

function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState("verifying"); // verifying | error
  const navigate = useNavigate();

  useEffect(() => {
    const token = searchParams.get("token");
    if (!token) {
      setStatus("error");
      return;
    }

    const verify = async () => {
      try {
        await client.get(`/verify-email?token=${token}`);
        navigate("/login", { state: { message: "Email verified! You can now log in." } });
      } catch (err) {
        setStatus("error");
      }
    };

    verify();
  }, []);

  return (
    <main className="AuthPage">
      {status === "verifying" && (
        <>
          <h1>Verifying...</h1>
          <p style={{ opacity: 0.7 }}>Please wait while we verify your email.</p>
        </>
      )}

      {status === "error" && (
        <>
          <h1>Verification Failed</h1>
          <p style={{ opacity: 0.85, marginBottom: "16px" }}>
            This verification link is invalid or has expired.
          </p>
          <p style={{ opacity: 0.85, fontSize: "13px", marginBottom: "24px" }}>
            Please register again or contact support at{" "}
            <a href="mailto:support@myjourneytrails.com">support@myjourneytrails.com</a>
          </p>
          <button onClick={() => navigate("/register")}>Register Again</button>
        </>
      )}
    </main>
  );
}

export default VerifyEmailPage;